import { createSelector } from 'reselect'
import { isEqual } from 'lodash'
import { RootStoreState } from '@src/models/app.types'

export const sensorStoreSelector = (state: RootStoreState) => state.sensor

export const sensorSelector = createSelector(sensorStoreSelector, (state) => state.sensor, {
  memoizeOptions: {
    resultEqualityCheck: isEqual,
  },
})

export const sensorActivationTimeSelector = (state: RootStoreState) =>
  sensorSelector(state)?.activationTime
